// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { removeWhitespaceAndSpecialChars } from '../helpers/commons'
import loadable from '@loadable/component'
import { jsx } from 'theme-ui'
import Accordion from './platinum/accordion'
const NavAccordion = loadable(() => import('./nav-accordion.connected'))
const PlatinumAccordion = loadable(() => import('./platinum/types-of-cards-accordion'))

export default (props) => {
  if (props?.variant === 'dropdown') {
    return <NavAccordion {...props} />
  } else if (props?.variant === 'desktopCards') {
    return (
      <div id={removeWhitespaceAndSpecialChars(props.name)}>
        <div className={props.newSection ? 'NewSectionWrapper' : ''}>
          <PlatinumAccordion {...props} />
        </div>
      </div>
    )
  } else {
    return (
      <div className={props.newSection ? 'NewSectionWrapper' : ''}>
        <Accordion {...props} />
      </div>
    )
  }
}
